import { motion } from 'framer-motion';
import React from 'react';

const skills = [
    { name: 'HTML' },
    { name: 'CSS ' },
    { name: 'JavaScript'},
    { name: 'Typescript' },
    { name: 'React'},
    { name: 'Node.js' },
    { name: 'Express' },
    { name: 'MongoDB' },
    { name: 'Git & GitHub' },
    { name: 'Figma'},
    { name: 'Bootstrap' },
    { name: 'Tailwind CSS' },

];

const Skills = () => {
    return (
        <section id="skills" className="my-5">
            <div className="container">
                <motion.h2
                    className="text-center mb-4"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    My Skills
                </motion.h2>
                <div className="row">
                    {skills.map((skill, index) => (
                        <motion.div
                            key={index}
                            className="col-md-2 mb-3"
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                        >
                            <div className="card shadow-sm border-0 rounded-3 p-3 text-center skills">
                                <h5 className="skill-card mb-1 text-lg">{skill.name}</h5>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Skills;
